module.exports = __webpack_public_path__ + "media/images/esc_convenio_CLARITO-0ad4ae8dd8480163586863c8181cadae.svg";